<div class="section-title">Connection Log for {{asset.asset_name}}</div>

<ng-template ngbModalContainer></ng-template>

@if (pageLogs === undefined) {
<div class="loading-status">
	<div class="logo-spin"></div>
	Loading connection logs...
</div>
}

@if (pageLogs && pageLogs.length === 0) {
<div class="loading-status">
	No connection logs available
</div>
}

@if (pageLogs && pageLogs.length > 0) {
<table class="log system" [class.loading]="pageLoading">
	<thead>
		<tr>
			<th>Timestamp</th>
			<th class="hide-md">IP</th>
			<th>Status</th>
			<th class="hide-md" title="HTTP Method">HTTP</th>
			<th>Path</th>
			<th class="hide-md" title="Query"><i class="icon-help-circled"></i></th>
			<th class="hide-md">Duration</th>
			<th class="hide-md">DB</th>
			<th class="hide-md">Analysis</th>
			<th class="hide-md" title="Request size"><i class="icon-up-circled2"></i></th>
			<th class="hide-md" title="Response size"><i class="icon-down-circled2"></i></th>
			<th class="request-message">Message</th>
			<th class="hide-md" title="Exception"><i class="icon-attention-circled"></i></th>
		</tr>
	</thead>
	@for (log of pageLogs; track log) {
	<tbody>
		@if (log.method !== null) {
		<tr>
			<td>
				<span title="{{log.ts}}">
					<span>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</span>
				</span>
			</td>
			<td class="hide-md"><a (click)="applyFilter('remote_ip', log.remote_ip)" href="javascript:void(0)">{{log.remote_ip}}</a></td>
			<td><a (click)="applyFilter('status_code', log.status_code)" href="javascript:void(0)" [style.color]="log.status_code | httpstatuscolor">{{log.status_code}}</a>
			</td>
			<td class="hide-md"><a (click)="applyFilter('http_method', log.method)" href="javascript:void(0)">{{log.method}}</a></td>
			<td><a (click)="applyFilter('path', log.path)" href="javascript:void(0)">{{log.path}}</a></td>
			<td class="hide-md">@if (log.query) {
				<i title="{{log.query}}" class="icon-help-circled"></i>
				}
			</td>
			<td class="hide-md"><span [class.log-long-response]="log.response_time_us > 200000">{{log.response_time_us / 1000.0 | number :
					"1.0-0"}}</span>ms
			</td>
			<td class="hide-md">{{log.db_time_us ? (log.db_time_us / 1000.0 | number : "1.0-0") + "ms" : ""}}</td>
			<td class="hide-md">{{log.analysis_time_us ? (log.analysis_time_us / 1000.0 | number : "1.0-0") + "ms" : ""}}</td>
			<td class="hide-md">{{log.request_size | filesize}}</td>
			<td class="hide-md">{{log.response_size | filesize:2}}</td>
			<td class="request-message">{{log.message}}</td>
			<td class="hide-md">@if (log.exception && log.exception !== 'true') {
				<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable"></i>
				}
			</td>
		</tr>
		}
		@if ((log.method === null) && (log.remote_ip !== null)) {
		<tr>
			<td>
				<span title="{{log.ts}}">
					<span>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</span>
				</span>
			</td>
			<td><a (click)="applyFilter('remote_ip', log.remote_ip)" href="javascript:void(0)">{{log.remote_ip}}</a></td>
			<td colspan="10" class="system-message" [class.log-error]="log.exception">{{log.message}}</td>
			<td>@if (log.exception && log.exception !== 'true') {
				<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable"></i>
				}
			</td>
		</tr>
		}
		@if ((log.method === null) && (log.remote_ip === null) && (log.response_time_us !== null)) {
		<tr>
			<td>
				<span title="{{log.ts}}">
					<span>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</span>
				</span>
			</td>
			<td colspan="5" class="system-message" [class.log-import-message]="log.type === 1" [class.log-error]="log.exception">{{log.message}}</td>
			<td colspan="5"><span [class.log-long-response]="log.response_time_us > 5000000">{{log.response_time_us / 1000.0
					| number : "1.0-0"}}</span>ms
			</td>
			<td>@if (log.exception && log.exception !== 'true') {
				<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable"></i>
				}
			</td>
		</tr>
		}
		@if ((log.method === null) && (log.remote_ip === null) && (log.response_time_us === null)) {
		<tr>
			<td>
				<span title="{{log.ts}}">
					<span>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</span>
				</span>
			</td>
			<td colspan="11" class="system-message" [class.log-import-message]="log.type === 1" [class.log-error]="log.exception">{{log.message}}</td>
			<td>@if (log.exception && log.exception !== 'true') {
				<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable"></i>
				}
			</td>
		</tr>
		}
	</tbody>
	}
</table>
<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
	[rotate]="true"></ngb-pagination>
}

<div class="row mb-4">
	@if (filters.remote_ip) {
	<div class="col-sm-6 col-md-4">
		IP: {{filters.remote_ip}}
		<i (click)="removeFilter('remote_ip')" class="icon-minus-circled clickable"></i>
	</div>
	}
	@if (filters.status_code) {
	<div class="col-sm-6 col-md-4">
		Status: {{filters.status_code}}
		<i (click)="removeFilter('status_code')" class="icon-minus-circled clickable"></i>
	</div>
	}
	@if (filters.http_method) {
	<div class="col-sm-6 col-md-4">
		Method: {{filters.http_method}}
		<i (click)="removeFilter('http_method')" class="icon-minus-circled clickable"></i>
	</div>
	}
	@if (filters.path) {
	<div class="col-sm-6 col-md-4">
		Path: {{filters.path}}
		<i (click)="removeFilter('path')" class="icon-minus-circled clickable"></i>
	</div>
	}
</div>
<div class="row">
	<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.only_errors" (ngModelChange)="refreshTable()"> Only errors</label></div>
</div>


<ng-template #exceptionModal let-c="close">
	<div class="modal-header">
		<h4 class="modal-title">Exception detail</h4>
		<button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="c()"></button>
	</div>
	<div class="modal-body">
		<h3>Exception</h3>
		<pre>{{selectedException | json}}</pre>
		@if (selectedExceptionStack) {
		<div>
			<h3>Stack</h3>
			<pre>{{selectedExceptionStack}}</pre>
		</div>
		}
		@if (selectedExceptionSubStack) {
		<div>
			<h3>Detail stack</h3>
			<pre>{{selectedExceptionSubStack}}</pre>
		</div>
		}
	</div>
</ng-template>